import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TooltipDirective } from '@shared/directives/tooltip.directive';

@Component({
  imports: [FormsModule, TooltipDirective],
  selector: 'aux-radio-button',
  styleUrl: './radio-button.component.scss',
  template: `
    <div class="flex items-center" [auxTooltip]="tooltip">
      @let isCurrentRadioSelected = value === selectedValue;

      <input
        [id]="id"
        type="radio"
        class="mr-1.5 shrink-0 border-aux-gray-dark text-aux-blue ring-aux-blue checked:bg-none focus:ring-aux-blue"
        [value]="value"
        [name]="name"
        (change)="onChange($any($event.target).value)"
        [checked]="isCurrentRadioSelected"
        [disabled]="disabled"
      />

      <label class="flex flex-col" [for]="id">
        <span [class.font-medium]="!!subLabel">{{ label }}</span>
        @if (subLabel) {
          <span [class.font-normal]="isCurrentRadioSelected" class="font-light italic">
            {{ subLabel }}
          </span>
        }
      </label>
    </div>
  `,
})
export class RadioButtonComponent {
  @Input() disabled = false;
  @Input({ required: true }) id!: string;
  @Input() label!: string;
  @Input() name!: string;
  @Input() selectedValue?: null | string;
  @Input() subLabel?: string;
  @Input() tooltip = '';
  @Input() value!: string;

  onChange = (_value: string) => {};

  setSelectedValue(value: string) {
    this.selectedValue = value;
    this.onChange(value);
  }
}
